import React from "react";
import ProfileView from "./ProfileView";
export default function Profile() {
  return <ProfileView mode="self" />;
}
